module.exports = __webpack_public_path__ + "img/decors_n.a7cc1629.png";